export default __webpack_public_path__ + "static/media/Introduction.ca752205.png";